import { render } from "./VerifyOtpPopup.vue?vue&type=template&id=3c25218e&scoped=true&ts=true"
import script from "./VerifyOtpPopup.vue?vue&type=script&lang=ts"
export * from "./VerifyOtpPopup.vue?vue&type=script&lang=ts"

import "./VerifyOtpPopup.vue?vue&type=style&index=0&id=3c25218e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c25218e"]])

export default __exports__